<template>
  <div class="main stake">
    <div class='container'>
      <!-- Locked Funds -->
      <b-row class='mb-5'>
        <LockedFunds :amount="this.assets.list[1].supply"/>
      </b-row>
      <!-- form -->
      <b-row class='pt-2'>
        <FormComponets
          type = "users"
          :balance= "this.assets.list[0].balance"
          :_disabled.sync= "this.form.disabled"
          :aproved= "this.form.aproved"
          :loggenIn= "this.form.loggenIn"
          :min="this.form.min"
          :_max.sync="this.form.max"
          @event="formEvent"
        />
        <DistributionComponets
          type='users'
          :dataPieChart='this.getValues'
          :linkSC='this.getLinkSC'
        />
      </b-row>
      <!-- list-->
      <b-row class='mb-5 pt-3'>
        <b-col cols=12>
            <h4 class="mb-0 pb-3 text-center txt-color-secondary">Movements</h4>
        </b-col>
        <MovementsComponents :list='this.getMovements'/>
      </b-row>
      <b-row class="mb-5">
        <b-col cols=12>
          <h5 class="mb-0 pb-3 text-center txt-color-secondary">Withdrawals</h5>
        </b-col>
        <b-col cols=12>
          <b-card no-body class='py-4'>
            <div v-if="this.withdrawals.length === 0" style="height: 135px; display: flex; justify-content: center; align-items: center;">
              <h6 class='mb-0 color-primary'>The list is empty</h6>
            </div>
            <b-list-group flush>
              <b-list-group-item
                button
                style="background: none;"
                class="mb-2 box px-4 py-0"
                v-for="(item, index) in this.withdrawals" v-bind:key="index"
              >
                <b-container class='py-2'>
                  <b-row>
                    <b-col class="p-0 txt-color-secondary text-right text-sm-left" cols=12 sm=6>
                      <p class="m-0">{{item.timestamp}}</p>
                    </b-col>
                    <b-col class="p-0 txt-color-secondary text-right" cols=12 sm=6>
                      <p class="color-primary m-0"><strong>{{item.value}} SGBT</strong></p>
                    </b-col>
                  </b-row>
                </b-container>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-col>
      </b-row>
      <div style="height: 200px"></div>
    </div>
  </div>
</template>

<script>
import LockedFunds from '@/components/stake/LockedFundsComponets'
import FormComponets from '@/components/stake/formComponets'
import DistributionComponets from '@/components/stake/distributionComponents'
import MovementsComponents from '@/components/stake/movementsComponents'

import { mapGetters } from 'vuex'
import ApiWallet from '@/services/ApiWallet.service'

export default {
  components: {
    LockedFunds,
    FormComponets,
    DistributionComponets,
    MovementsComponents
  },
  data () {
    return {
      linkSC: 'https://tronscan.org/#/token20/TCqdu9enyuh3TiX4HiwVbGovf24YiMKgYz/holders',
      values: [],
      movements: [],
      withdrawals: [],
      assets: {
        error: false,
        list: [
          {
            name: 'SGBT',
            protocol: 'trc-20',
            address: 'TCdCXwD9GPmJUVaB64KeGU6ovd34XgFNe7',
            supply: 0,
            instance: null,
            balance: 0,
            allowance: 0
          },
          {
            name: 'SGBT Stake',
            protocol: 'trc-20',
            address: 'TCnGHiYbN1JiZ3VQbxXnBis1BTnWEzkhdT',
            supply: 0,
            instance: null
          }
        ]
      },
      smartInfinity: {
        instance: null,
        address: '',
        isRegistered: false
      },
      tronGrid: null,
      form: {
        disabled: true,
        aproved: 0,
        loggenIn: false,
        min: 1_000,
        max: 1_000_000
      }
    }
  },
  computed: {
    ...mapGetters({
      getUserAddress: 'getAddress',
      getStatusAuthWallet: 'auth/getStatusAuthWallet',
      getOptionsAuthWallet: 'auth/getOptionsAuthWallet'
    }),
    getValues () { return this.values },
    getLinkSC () { return this.linkSC }
  },
  watch: {
    async getStatusAuthWallet (_new, old) {
      console.log('getStatusAuthWallet: ', { old, _new })
      console.log('walletIsInstalled', this.$store.getters.walletIsInstalled)
      if (this.$store.getters.walletIsInstalled) {
        // logged in
        if (old === this.getOptionsAuthWallet.LOGGING_IN &&
          _new === this.getOptionsAuthWallet.LOGGED_IN
        ) {
          this.loggenIn()
        } else {
          // NOT LOGGED IN
          if (old === this.getOptionsAuthWallet.LOGGING_IN && _new === this.getOptionsAuthWallet.NOT_LOGGED_IN) {
            this.notLoggedIn()
          }
        }
      } else {
        // NOT LOGGED IN
        if (_new === this.getOptionsAuthWallet.NOT_LOGGED_IN) {
          this.notLoggedIn()
        }
      }
    }
  },
  created () {
    // set pie chart
    const env = {
      pro: {
        address: {
          smartInfinity: '',
          token: ''
        }
      },
      dev: {
        address: {
          smartInfinity: 'TSFLpvYrCwsMSUQgdd5H3pn5U5z2D1ASg4',
          token: ''
        }
      }
    }

    const setup = env.dev
    this.smartInfinity.address = setup.address.smartInfinity
    this.values = []
    this.update()
  },
  async mounted () {},
  async updated () {},
  methods: {
    async setPartner () {
      this.partner = {
        id: 0
      }
      const split = await this.$route.fullPath.split('/')
      if (split[split.length - 2] && split[split.length - 2] === 'ref') {
        if (split[split.length - 1] && split[split.length - 1] !== '' && Number.isInteger(Number(split[split.length - 1]))) {
          this.partner.id = Number(split[split.length - 1])
        }
      }
      console.log('partner', this.partner)
    },
    async isSmartInfinity () {
      await this.smartInfinity.instance.users(this.getUserAddress).call()
        .then(resp => {
          if (this.tronGrid.tronWeb.toDecimal(resp.id._hex) !== 0) {
            this.smartInfinity.isRegistered = true
            console.log('Smart Infinity', this.smartInfinity.isRegistered)
          }
        })
        .catch(e => console.log({ e }))
    },
    async setList () {
      this.movements = []
      var list = []
      list.push({
        id: 1,
        address: 'xyz',
        value: this.GLOBAL._toDecimal(400_000_000_000_000, 9),
        start: '1000000',
        contador: 365// Math.trunc(((new Date(element.block_timestamp).getTime() + (365 * diasMS)) - today.getTime()) / diasMS) + ' days'
      })
      this.movements = list
    },
    getMovements () {
      return this.movements
    },
    update () {
      if (this.$store.getters.walletIsInstalled) {
        if (this.getStatusAuthWallet === this.getOptionsAuthWallet.LOGGED_IN) {
          this.loggenIn()
        } else {
          if (this.getStatusAuthWallet === this.getOptionsAuthWallet.NOT_LOGGED_IN) {
            this.notLoggedIn()
          }
        }
      } else {
        // NOT LOGGED IN
        if (this.getStatusAuthWallet === this.getOptionsAuthWallet.NOT_LOGGED_IN) {
          this.notLoggedIn()
        }
      }
    },
    async notLoggedIn () {
      console.log('notLoggedIn')
      this.$store.commit('setLoading', true)
      try {
        this.tronGrid = new ApiWallet()
        await this.getContractAssets()
        if (!this.assets.error) {
          await this.updateWithExtension()
        }
      } catch (e) { console.log({ e }) }
      this.$store.commit('setLoading', false)
    },
    async getContractAssets () {
      try {
        if (this.assets.list[0].instance === null) {
          this.assets.list[0].instance = await this.tronGrid.getContract(this.assets.list[0].address)
        }
        //
        if (this.assets.list[1].instance === null) {
          this.assets.list[1].instance = await this.tronGrid.getContract(this.assets.list[1].address)
        }
        /* SC smart infinity */
        if (this.smartInfinity.instance === null) {
          this.smartInfinity.instance = await this.tronGrid.getContract(this.smartInfinity.address)
        }
      } catch (e) {
        this.assets[0].instance = null
        this.assets[1].instance = null
        this.assets.error = true
        console.log('error: getContractAssets', { e })
      }
    },
    async updateWithExtension () {
      this.form.loggenIn = false
      this.form.aproved = 0
      this.form.disabled = true
      this.assets.list[0].balance = 0
      //
      await this.setStatus()
      //
      await this.setAllStake()
      //
      await this.setWithdrawals()
    },
    async setStatus () {
      // get Status
      const status = await this.assets.list[1].instance.status().call()
      const mineable = this.tronGrid.tronWeb.toDecimal(status.mineable._hex)
      const supply = this.tronGrid.tronWeb.toDecimal(status._supply._hex)
      const paid = this.tronGrid.tronWeb.toDecimal(status.paid._hex)
      const reward = this.tronGrid.tronWeb.toDecimal(status.reward._hex)
      this.assets.list[1].supply = supply

      const data = [
        { name: 'Mineable', value: mineable, show: true },
        { name: 'Mined', value: reward - paid, show: true },
        { name: 'Locked', value: supply, show: true }
      ]
      this.setPieChart(data)
    },
    setPieChart (data) {
      this.values = []
      data.forEach(element => {
        this.values.push(element)
      })
    },
    setForm () {
      this.form.disabled = true
      this.form.aproved = 0
    },
    cls () {
      //
      this.setForm()
    },
    async loggenIn () {
      console.log('LOGGED_IN')
      this.$store.commit('setLoading', true)
      try {
        this.cls()
        this.tronGrid = new ApiWallet()
        this.tronGrid.tronWeb.setAddress(this.getUserAddress)
        await this.getContractAssets()
        if (!this.assets.error) {
          await this.updateALL()
        }
      } catch (e) { console.log({ e }) }
      this.$store.commit('setLoading', false)
    },
    async setAllStake () {
      this.movements = []
      var movements = []
      try {
        var today = new Date()
        const events = await this.tronGrid.getEventByContract(this.assets.list[1].address, 'event_stake')
        events.data.data.forEach(element => {
          const _seconds = element.result._seconds
          const end = new Date(element.block_timestamp + _seconds * 1000)
          console.log({ element })
          console.log('end: ', end)
          movements.push({
            id: element.transaction_id,
            address: this.tronGrid.tronWeb.address.fromHex(element.result.account),
            value: this.GLOBAL._toDecimal(element.result.amount, 9),
            times: this.GLOBAL.timeStr(_seconds),
            contador: this.GLOBAL.timeStr(
              (end.getTime() - today.getTime()) / 1000
            )
          })
        })
        this.movements = movements
        console.log({ movements })
      } catch (e) { console.log({ e }) }
    },
    async setWithdrawals () {
      this.withdrawals = []
      var list = []
      try {
        let events = await this.tronGrid.getEventByContract(this.assets.list[1].address, 'event_reward')
        events.data.data.forEach(element => {
          list.push({
            id: element.transaction_id,
            address: this.tronGrid.tronWeb.address.fromHex(element.result.account),
            value: this.GLOBAL._toDecimal(element.result.amount, 9),
            timestamp: new Date(element.block_timestamp).toLocaleString()
          })
        })
        events = await this.tronGrid.getEventByContract(this.assets.list[1].address, 'event_liquidate_stake')
        events.data.data.forEach(element => {
          list.push({
            id: element.transaction_id,
            address: this.tronGrid.tronWeb.address.fromHex(element.result.account),
            value: this.GLOBAL._toDecimal(element.result.amount, 9),
            timestamp: '(Liquidated) ' + new Date(element.block_timestamp).toLocaleString()
          })
        })
        this.withdrawals = list
      } catch (e) { console.log({ e }) }
    },
    async updateALL () {
      // update default
      await this.updateWithExtension()
      // balance SGBT
      this.assets.list[0].balance = await this.tronGrid.balanceOf(
        this.assets.list[0].instance,
        this.getUserAddress
      )
      const available = this.assets.list[0].balance / Math.pow(10, 9)
      console.log('available', available)
      if (available < this.form.max) {
        this.form.max = available
      }
      // set formulario
      this.form.loggenIn = true
      this.form.disabled = true
      await this.setAllowance()
      this.form.disabled = false
      //
      if (this.form.aproved > 0) {
        this.setPartner()
        await this.isSmartInfinity()
      }
    },
    /* */
    async setAllowance () {
      console.log('setAllowance')
      await this.assets.list[0].instance.allowance(this.getUserAddress, this.assets.list[1].address).call()
        .then(resp => {
          let allowance = 0
          if (resp._hex !== undefined) {
            allowance = this.tronGrid.tronWeb.toDecimal(resp._hex)
          } else {
            // app movil tronlink
            if (resp.remaining !== undefined) {
              allowance = this.tronGrid.tronWeb.toDecimal(resp.remaining._hex)
            }
          }
          if (allowance !== 0) {
            this.form.aproved = Number(this.GLOBAL._toDecimal(allowance, 9).toString().replaceAll(',', ''))
          } else {
            this.form.aproved = 0
          }
          console.log({ allowance })
          console.log('this.form.aproved ', this.form.aproved)
        })
        .catch(e => {
          console.log('error', { e })
        })
    },
    async formEvent (event) {
      const vm = this
      console.log({ event })
      this.form.disabled = true
      // notific
      if (this.tronGrid.readOnly) {
        this.$notificacionSimple('Error', 'read-only connections.')
        this.form.disabled = false
        return
      }
      const confirm = await vm.$notificacionSimpleConfirm('Notification', 'Purchases take 1-5 minutes to complete. Do you wish to continue?') // ES : Las compras tardan de 1 a 5 minutos en completarse. ¿Desea continuar?
      console.log('confirm', confirm)
      if (!confirm) {
        this.form.disabled = false
        return
      }

      this.$store.commit('setLoading', true)
      const mult = Math.pow(10, 6)
      const stake = async () => {
        const options = {
          feeLimit: 100 * mult,
          callValue: 0,
          shouldPollResponse: true
        }
        console.log('event.amount: ', event.amount)
        const amount = Number(event.amount).toFixed(9) * Math.pow(10, 9)
        console.log({ amount })
        if (event.title === 'approve') {
          return await vm.assets.list[0].instance.approve(vm.assets.list[1].address, amount).send(options)
        } else {
          if (vm.smartInfinity.isRegistered) {
            console.log('stake SI')
            return await vm.assets.list[1].instance.stakeSI(amount, 1, this.partner.id).send(options)
          }
          console.log('stake')
          return await vm.assets.list[1].instance.stake(amount, 1, this.partner.id).send(options)
        }
      }
      await stake()
        .then(async () => {
          vm.$store.commit('setLoading', false)
          await vm.$notificacionSimple('success', 'The operation was successful.')
        }).catch(async (e) => {
          console.log('error', { e })
          vm.$store.commit('setLoading', false)
          await vm.$notificacionSimple('Error', (e.error) ? e.error : e)
        })
      this.$store.commit('setLoading', true)
      await this.updateALL()
      this.$store.commit('setLoading', false)
    }
  }
}
</script>

<style scoped>
</style>
